// src/components/Funnels/SkillToSaleQuizFunnel/quizQuestions.tsx
import React from "react";
import { BookOpen, Award, Users, Target, DollarSign, TrendingUp } from "lucide-react";
import { Question } from "./QuestionCard";

/**
 * QUESTIONS moved to its own file.
 * Exports: QUESTIONS: Question[]
 */

export const QUESTIONS: Question[] = [
  {
    id: "knowledge",
    title: "What knowledge or skill do you have?",
    subtitle: "Tell us your area of expertise",
    icon: <BookOpen className="w-8 h-8" />,
    type: "select",
    options: [
      "Digital Marketing & Social Media",
      "Business & Entrepreneurship",
      "Finance & Investment",
      "Technology & Programming",
      "Health & Fitness",
      "Personal Development",
      "Relationships & Dating",
      "Photography & Video",
      "Writing & Content Creation",
      "Cooking & Food",
      "Fashion & Beauty",
      "Real Estate",
      "Other Professional Skill",
    ],
  },
  {
    id: "experience",
    title: "How experienced are you in this field?",
    subtitle: "Your level of expertise matters",
    icon: <Award className="w-8 h-8" />,
    type: "select",
    options: [
      "Beginner (0-1 years)",
      "Intermediate (2-3 years)",
      "Advanced (4-7 years)",
      "Expert (8+ years)",
      "Industry Leader/Recognized Authority",
    ],
  },
  {
    id: "audience",
    title: "Do you have an existing audience?",
    subtitle: "Current following across all platforms",
    icon: <Users className="w-8 h-8" />,
    type: "select",
    options: [
      "No audience (0-100 followers)",
      "Small audience (100-1,000)",
      "Growing audience (1K-10K)",
      "Established audience (10K-50K)",
      "Large audience (50K+)",
    ],
  },
  {
    id: "timeCommitment",
    title: "How much time can you dedicate weekly?",
    subtitle: "Time investment affects earning potential",
    icon: <Target className="w-8 h-8" />,
    type: "select",
    options: [
      "1-5 hours (Side hustle)",
      "6-15 hours (Part-time)",
      "16-30 hours (Serious commitment)",
      "31-40 hours (Full-time)",
      "40+ hours (All-in entrepreneur)",
    ],
  },
  {
    id: "currentIncome",
    title: "Current monthly income from this knowledge?",
    subtitle: "Your starting point",
    icon: <DollarSign className="w-8 h-8" />,
    type: "select",
    options: [
      "₦0 (Just starting)",
      "₦1K - ₦50K",
      "₦51K - ₦200K",
      "₦201K - ₦500K",
      "₦501K - ₦1M",
      "₦1M+",
    ],
  },
  {
    id: "goal",
    title: "What's your monthly income goal?",
    subtitle: "Dream big, but be realistic",
    icon: <TrendingUp className="w-8 h-8" />,
    type: "select",
    options: [
      "₦100K - ₦500K",
      "₦500K - ₦1M",
      "₦1M - ₦3M",
      "₦3M - ₦5M",
      "₦5M - ₦10M",
      "₦10M+",
    ],
  },
];

export default QUESTIONS;
